module.exports = __webpack_public_path__ + "img/icon_continuous_gray.d328ea4f.svg";